import React, { useCallback, useState } from "react";

import {
  DivGrid,
  TitleText,
  ValueText,
  GridValues,
  DivForm,
  MidTitle,
  DivButton,
  DivSuccessSend,
} from "./styles";
import { BigTitle } from "../Holderdata/styles";
import Button from "@mui/material/Button";
import error from "../../../Toast/Image/error.svg";
import success from "../../../Toast/Image/check.svg";
import imgClickSign from "./images/imgClickSign.svg";
import logoClickSign from "./images/LogoClickSign.svg";
import { useProgress } from "../../../../hooks/progress";
import api from "../../../../services/api";
import {
  readDataStorage,
  writeStorage,
} from "../../../../utils/storage/storage";
import moment from "moment";
import Toast from "../../../Toast/Toast";
import facebook from "./images/facebook.svg";
import instagram from "./images/instagram.svg";
import getStateAbbreviation from "../StateAbbreviation";
import { useContextPanel } from "../ContextPanel";

const HolderConfirmation: React.FC = () => {
  const { idCard } = readDataStorage("home");
  const localStorageCard = readDataStorage("card");
  const { confirmation } = readDataStorage("success");
  const [successSend, setSuccessSend] = useState(false);
  const [list, setList] = useState<any>([]);
  const { setLoad } = useProgress();
  const { setComponent } = useContextPanel();
  const [process, setProcess] = useState(false);

  const listBanks = useCallback(async () => {
    setLoad(true);
    const stateAbbreviation = getStateAbbreviation(localStorageCard?.Estado);
    await api
      .get("/csp/banco/listar/" + stateAbbreviation)
      .then((response) => {
        let localBanks = [];
        const {
          data: {
            mensagem: { bancos },
          },
        } = response;
        for (const k in bancos) {
          const { nomBan } = bancos[k];
          localBanks.push({ value: bancos[k], label: nomBan });
        }

        writeStorage({
          key: "bancos",
          object: {
            bancosStorage: localBanks,
          },
        });
        setLoad(false);
        window.location.href = "/onboarding/step/3";
      })
      .catch((err) => {
        setLoad(false);
        console.error(err);
      });
    setLoad(false);
  }, [setLoad, localStorageCard?.Estado]);

  const disableBackButton = () => {
    window.history.pushState(null, window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, window.location.href);
    };
  };

  const successConfirmation = useCallback(async () => {
    setSuccessSend(true);
    writeStorage({
      key: "success",
      object: {
        confirmation: true,
      },
    });
    disableBackButton();
  }, [setSuccessSend]);

  const handleClickPage = useCallback(
    (e: any) => {
      listBanks();
      setComponent(e);
    },
    [listBanks, setComponent]
  );

  let toastProperties: {
    id: number;
    title: string;
    description: string;
    backgroundColor: string;
    icon: any;
  } | null = null;

  const showToast = useCallback((type: any) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "error":
        // eslint-disable-next-line
        toastProperties = {
          id,
          title: "",
          description: "Erro ao enviar dados",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "enviando":
        // eslint-disable-next-line
        toastProperties = {
          id,
          title: "",
          description: "Enviando dados...",
          backgroundColor: "#D72828",
          icon: success,
        };
        break;
      case "enviado":
        // eslint-disable-next-line
        toastProperties = {
          id,
          title: "",
          description: "Dados enviados com sucesso",
          backgroundColor: "#D72828",
          icon: success,
        };
        break;
      case "404":
        toastProperties = {
          id,
          title: "",
          description: "ID não encontrado",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "422":
        toastProperties = {
          id,
          title: "",
          description: "Dados inválidos",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "423":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao enviar dados",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      case "500":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao enviar dados",
          backgroundColor: "#D72828",
          icon: error,
        };
        break;
      default:
        setList([]);
    }
    setList([...list, toastProperties]);
  }, []);

  const handleSignDocument = useCallback(async () => {
    setLoad(true);
    setProcess(true);
    await api
      .post("/csp/usuario/alterar/contrato/", {
        idCard: idCard,
      })
      .then((res) => {
        if (res.status === 200) {
          setLoad(false);
          successConfirmation();
          //LocalStorage
          localStorage.removeItem("@AXS-adesao");
          localStorage.removeItem("@AXS-economia");
          localStorage.removeItem("@AXS-home");
          localStorage.removeItem("@AXS-beneficios");
          localStorage.removeItem("@AXS-card");
          localStorage.removeItem("@AXS-holderdata");
          localStorage.removeItem("@AXS-filldata");
          localStorage.removeItem("@AXS-consumo");
          localStorage.removeItem("@AXS-commercial");
          localStorage.removeItem("@AXS-modalCheck");
          localStorage.removeItem("@AXS-bancos");
          localStorage.removeItem("@AXS-confirmationFatura");
          localStorage.removeItem("@AXS-confirmationData");
          //SessionStorage
          sessionStorage.removeItem("@AXS-adesao");
          sessionStorage.removeItem("@AXS-economia");
          sessionStorage.removeItem("@AXS-home");
          sessionStorage.removeItem("@AXS-beneficios");
          sessionStorage.removeItem("@AXS-card");
          sessionStorage.removeItem("@AXS-holderdata");
          sessionStorage.removeItem("@AXS-filldata");
          sessionStorage.removeItem("@AXS-consumo");
          sessionStorage.removeItem("@AXS-commercial");
          sessionStorage.removeItem("@AXS-modalCheck");
          sessionStorage.removeItem("@AXS-bancos");
          sessionStorage.removeItem("@AXS-confirmationFatura");
          sessionStorage.removeItem("@AXS-confirmationData");
        }
      })
      .catch((error) => {
        setLoad(false);
        console.log(error.response.status);
        if (error.response.status === 404) {
          showToast("404");
        }
        if (error.response.status === 422) {
          showToast("422");
        }
        if (error.response.status === 423) {
          showToast("423");
        }
        if (error.response.status === 500) {
          showToast("500");
        }
      });
    setProcess(false);
  }, [setLoad, showToast, idCard, successConfirmation]);

  const handleSendData = useCallback(
    async (e: any) => {
      handleSignDocument();
    },
    [handleSignDocument]
  );

  const handleWhatsAppOpen = () => {
    const phoneNumber = "554708007003434";
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}`;
    window.open(url, "_blank");
  };

  const handleSaibaMais = () => {
    const url = `https://www.clicksign.com/`;
    window.open(url, "_blank");
  };

  const handleFacebook = () => {
    const url = `https://www.facebook.com/axsenergia/`;
    window.open(url, "_blank");
  };

  const handleInstagram = () => {
    const url = `https://www.instagram.com/axsenergia/`;
    window.open(url, "_blank");
  };

  const handleBlog = () => {
    const url = `https://www.axsenergia.com.br/blog`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <div
        style={
          successSend === false && confirmation !== true
            ? {}
            : { display: "none" }
        }
      >
        <BigTitle>Por favor, confirme e envie os dados preenchidos:</BigTitle>
        <DivForm>
          <DivGrid
            style={localStorageCard?.Pessoa === "PF" ? {} : { display: "none" }}
          >
            <GridValues>
              <TitleText>Nome do titular da conta: </TitleText>{" "}
              <ValueText>{localStorageCard?.NomeTitularConta}</ValueText>
              <TitleText>Email:</TitleText>{" "}
              <ValueText>{localStorageCard?.Email}</ValueText>
              <TitleText>WhatsApp:</TitleText>{" "}
              <ValueText>{localStorageCard?.TelefoneTitularConta}</ValueText>
              <TitleText>Telefone:</TitleText>{" "}
              <ValueText>{localStorageCard?.TelefoneLigacao}</ValueText>
              <TitleText>Data de nascimento:</TitleText>{" "}
              <ValueText>
                {moment(
                  localStorageCard?.DataNascimentoTitular,
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY")}
              </ValueText>
            </GridValues>

            <GridValues>
              <TitleText>CPF/CNPJ:</TitleText>
              <ValueText>{localStorageCard?.CPF}</ValueText>
            </GridValues>
          </DivGrid>

          <DivGrid
            style={localStorageCard?.Pessoa === "PJ" ? {} : { display: "none" }}
          >
            <GridValues>
              <TitleText>Razão social: </TitleText>{" "}
              <ValueText>{localStorageCard?.RazaoSocialCard}</ValueText>
              <TitleText>Email:</TitleText>{" "}
              <ValueText>{localStorageCard?.Email}</ValueText>
              <TitleText>Telefone ou celular:</TitleText>{" "}
              <ValueText>{localStorageCard?.TelefoneTitularConta}</ValueText>
              <TitleText>Telefone:</TitleText>{" "}
              <ValueText>{localStorageCard?.TelefoneLigacao}</ValueText>
              <TitleText
                style={
                  localStorageCard?.Pessoa === "PJ" ? { display: "none" } : {}
                }
              >
                Data de nascimento:
              </TitleText>{" "}
              <ValueText
                style={
                  localStorageCard?.Pessoa === "PJ" ? { display: "none" } : {}
                }
              >
                {moment(localStorageCard?.dataNascimento, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )}
              </ValueText>
            </GridValues>

            <GridValues>
              <TitleText>CPF/CNPJ:</TitleText>
              <ValueText>{localStorageCard?.cpfCnpjCard}</ValueText>
            </GridValues>
          </DivGrid>
          <MidTitle
            style={localStorageCard?.Pessoa === "PJ" ? {} : { display: "none" }}
          >
            Dados do responsável legal:
          </MidTitle>
          <DivGrid
            style={localStorageCard?.Pessoa === "PJ" ? {} : { display: "none" }}
          >
            <GridValues>
              <TitleText>Nome do responsável legal: </TitleText>{" "}
              <ValueText>{localStorageCard?.NomeResponsavelLegal}</ValueText>
              <TitleText>Email:</TitleText>{" "}
              <ValueText>{localStorageCard?.EmailDoResponsavel}</ValueText>
              <TitleText>WhatsApp:</TitleText>{" "}
              <ValueText>
                {localStorageCard?.TelefoneResponsavelLegal}
              </ValueText>
              <TitleText>Data de nascimento:</TitleText>{" "}
              <ValueText>
                {moment(
                  localStorageCard?.DataNascimentoTitular,
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY")}
              </ValueText>
            </GridValues>

            <GridValues>
              <TitleText>CPF/CNPJ:</TitleText>
              <ValueText>{localStorageCard?.CPF}</ValueText>
              <TitleText>Optante pelo Simples</TitleText>
              <ValueText>{localStorageCard?.OptanteSimples}</ValueText>
            </GridValues>
          </DivGrid>

          <MidTitle>Dados de endereço:</MidTitle>
          <DivGrid>
            <GridValues>
              <TitleText>CEP:</TitleText>{" "}
              <ValueText>{localStorageCard?.CEP}</ValueText>
              <TitleText>Cidade:</TitleText>{" "}
              <ValueText>{localStorageCard?.Cidade}</ValueText>
              <TitleText>Logradouro:</TitleText>{" "}
              <ValueText>{localStorageCard?.Rua}</ValueText>
              <TitleText>Complemento:</TitleText>{" "}
              <ValueText>{localStorageCard?.Complemento}</ValueText>
            </GridValues>

            <GridValues>
              <TitleText>Estado:</TitleText>
              <ValueText>{localStorageCard?.Estado}</ValueText>
              <TitleText>Bairro:</TitleText>
              <ValueText>{localStorageCard?.Bairro}</ValueText>
              <TitleText>Número:</TitleText>
              <ValueText>{localStorageCard?.Numero}</ValueText>
            </GridValues>
          </DivGrid>

          <MidTitle>Dados da fatura:</MidTitle>
          <DivGrid>
            <GridValues>
              <TitleText>Número da instalação:</TitleText>{" "}
              <ValueText>{localStorageCard?.NumeroInstalacao}</ValueText>
            </GridValues>

            <GridValues>
              <TitleText>Data de vencimento da fatura</TitleText>
              <ValueText>{localStorageCard?.DataVencimentoFatura}</ValueText>
            </GridValues>
          </DivGrid>
          <DivGrid>
            <GridValues>
              <TitleText>Forma de pagamento escolhida:</TitleText>{" "}
              <ValueText>{localStorageCard?.FormaPagamento}</ValueText>
            </GridValues>
          </DivGrid>
          <br />
          <br />
          <br />
          <br />
          <div className="GridButtonsGrafico">
            <DivButton>
              <Button
                id="btnStep4Back"
                className="buttonBack"
                onClick={() => handleClickPage("HolderData")}
              >
                Corrigir os dados
              </Button>
            </DivButton>
            <DivButton>
              <Button
                disabled={process}
                id="btnStep4Next"
                className="buttonSend"
                onClick={handleSendData}
              >
                Confirmar e enviar
              </Button>
            </DivButton>
          </div>
        </DivForm>
      </div>

      <div style={confirmation === true ? {} : { display: "none" }}>
        <DivSuccessSend>
          <div className="title-clickSign">
            Parabéns por escolher a AXS Energia como fonte de energia limpa e
            renovável!
          </div>
          <div className="text-clickSign">
            Finalize sua adesão através do link enviado no seu WhatsApp. Após a
            validação da biometria, seu cadastro será avaliado pela nossa equipe
            comercial.
          </div>
          <div className="purpleText-clickSign">Você está quase lá!</div>
          <div className="imgClickSign">
            <img src={imgClickSign} alt=""></img>
          </div>
          <div className="imgLogoClickSign">
            <img src={logoClickSign} alt=""></img>
          </div>
          <div className="footer-ClickSign">
            Qualquer dúvida sobre o processo de contratação, basta entrar em
            contato com o nosso setor de atendimento através do e-mail
            <a href="mailto:atendimento@axsenergia.com.br">
              {" "}
              atendimento@axsenergia.com.br
            </a>{" "}
            ou telefone (WhatsApp){" "}
            <span className="span-ClickSign" onClick={handleWhatsAppOpen}>
              {" "}
              0800 700 3434
            </span>
            .
          </div>
          <br />
          <div className="footer-ClickSign">
            Sua adesão será realizada através da Plataforma Clicksign. A
            Clicksign é uma empresa de assinatura eletrônica que promove maior
            segurança e validade jurídica aos seus documentos assinados,
            <span className="span-ClickSign" onClick={handleSaibaMais}>
              {" "}
              saiba mais.
            </span>
            .
          </div>
          <div className="gridFooter-ClickSign">
            <div className="footer2-ClickSign" onClick={handleBlog}>
              Acesse o blog AXS Energia
            </div>
            <div className="footer-ClickSign">
              <img onClick={handleInstagram} src={instagram} alt=""></img>
              <img
                onClick={handleFacebook}
                style={{ marginLeft: "10px" }}
                src={facebook}
                alt=""
              ></img>
            </div>
          </div>
        </DivSuccessSend>
      </div>
    </>
  );
};

export default HolderConfirmation;
